import { CustomFieldDefinition, CustomFieldUsage } from '@alucio/aws-beacon-amplify/src/models';
import { useTemplateById } from 'src/state/redux/selector/emailTemplate';
import { useTenantCustomFields } from 'src/state/redux/selector/tenant';
import {
  emailFormConfig,
  getEmailTemplateDefaultValues,
  initialEmailTemplateValues,
} from './EmailTemplateConfig';
import { CustomFieldValuesMap, EmailTemplateORM } from 'src/types/orms';
import { StaticFields } from 'src/components/CustomFields/ComposableForm';

export interface EmailTemplateFormConfig {
  customFields: CustomFieldDefinition[],
  emailTemplateORM?: EmailTemplateORM,
  staticFields: StaticFields,
  staticValues: CustomFieldValuesMap,
  values: CustomFieldValuesMap,
}

const EMAIL_TEMPLATE_CONFIG  = { usages: { internalUsages: [CustomFieldUsage.EMAIL_TEMPLATE_FILTER] } }

const useEmailTemplateFormConfig = (templateId?: string): EmailTemplateFormConfig => {
  const emailTemplateORM = useTemplateById(templateId)
  const customFields = useTenantCustomFields(EMAIL_TEMPLATE_CONFIG);
  const defaultValues = getEmailTemplateDefaultValues(emailTemplateORM)
  const values = initialEmailTemplateValues(emailTemplateORM, customFields)
  const staticFields = { ...emailFormConfig, customValues: values }

  return {
    customFields,
    emailTemplateORM,
    staticFields,
    staticValues: defaultValues,
    values: values,
  }
}

export default useEmailTemplateFormConfig;
